import AIInsightsHighlight from "../../components/Landing/components/AIInsightsHighlight/AIInsightsHighlight";
import CoreFeatures from "../../components/Landing/components/CoreFeatures/CoreFeatures";
import DualPanel from "../../components/Landing/components/DualPanel/DualPanel";
import FeaturesFinalCTA from "../../components/Landing/components/FeaturesFinalCTA/FeaturesFinalCTA";
import FeaturesHero from "../../components/Landing/components/FeaturesHero/FeaturesHero";
import Footer from "../../components/Landing/components/Footer/Footer";
import Navbar from "../../components/Landing/components/Navbar/Navbar";
export default function FeaturesPage() {
  return (
    <>
      <Navbar />
      <main className="main-landing-page">
        <FeaturesHero />
        <CoreFeatures />
        <DualPanel />
        <AIInsightsHighlight />
        <FeaturesFinalCTA />
      </main>
      <Footer />
    </>
  );
}
